import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import * as $ from "jquery";
import {CommonService} from "../../../services/common.service";

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.css']
})
export class DialogBoxComponent implements OnInit {
  @ViewChild('anchor', {static: true, read: ViewContainerRef}) anchor;
  logoutOnClose: boolean = false;
  hideCloseBtn: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.anchor.clear();
    const {component, disableClose} = this.data;
    this.hideCloseBtn = !disableClose
    delete this.data?.component;
    const componentRef = this.anchor.createComponent(component);
    componentRef.instance.data = this.data;
    this.logoutOnClose = this.data.disableClose === true;
  }

  ngAfterViewInit() {
    const closeIcon = $('.close-icon-panel')[0];
    const container = $('.mat-mdc-dialog-container')[0];

    container.prepend(closeIcon);
  }

  closeDialog() {
    if (this.logoutOnClose) {
      this.commonService.logout()
    }
    this.dialogRef.close();
  }
}
